import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { OrderUploadContainer } from '@/components/screens/order-line-matching/order-upload-container'
import { ErrorPanel } from '@/components/ui/error-panel'
import { useMe, useMyIdentity } from '@/providers/me-context'

export const Route = createFileRoute('/t/$tenant_id/order_line_matching/upload')({ component: Page })
function Page() {
  const { tenant_id: tenantId } = Route.useParams()
  const me = useMe()
  const identity = useMyIdentity()
  const navigate = useNavigate()
  return (
    <div className="flex min-h-screen bg-background">
      <AppSidebarContainer tenantId={tenantId} />
      <main className="min-w-0 flex-1 space-y-4 p-6">
        {me.tenant.setting?.orderLineMatchingEnabled === true ? (
          <OrderUploadContainer
            key={tenantId}
            tenantId={tenantId}
            identityId={identity.id}
            onNavigateToList={() => {
              void navigate({ to: '/t/$tenant_id/order_line_matching', params: { tenant_id: tenantId } })
            }}
            onViewOrders={() => {
              void navigate({ to: '/t/$tenant_id/order_line_matching/orders', params: { tenant_id: tenantId } })
            }}
          />
        ) : (
          <ErrorPanel
            layout="section"
            title="発注明細照合機能が有効になっていません"
            description="ご利用を希望する場合は運営までお問い合わせください。"
          />
        )}
      </main>
    </div>
  )
}
